import React from 'react';
import clock from '../../../assets/icons/alarm-svgrepo-com.svg'
import marker from '../../../assets/icons/location-pin-svgrepo-com.svg'
import phone from '../../../assets/icons/phone-call-svgrepo-com.svg'

import InfoCard from '../InfoCard/InfoCard';


const InfoCards = () => {
    const cardData = [
        {
            id:1,
            name:'Opening hours',
            description:'Every day 10:am - 8:pm',
            icon:clock,
            bgClass:'bg-info'

        },
        {
            id:2,
            name:'Visit our location',
            description:'Brooklyn, NY 10036, United States',
            icon:phone,
            bgClass:'bg-neutral'

        },
        {
            id:3,
            name:'Contact us now',
            description:'+000 123 456789',
            icon:marker,
            bgClass:'bg-info'

        },
    ]
    return (
        <div className='lg:grid grid-cols-3 gap-4 '>

            {
                cardData.map(card=><InfoCard
                key={card.id}
                card={card}
                >

                </InfoCard>)
            }
            
        </div>
    );
};

export default InfoCards;